import { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { validateCommaSeparatedEmails } from './refiners';

const RECIPIENT = 'recipient';
const RECIPIENTS = 'recipients';
const MESSAGE = 'message';

export const SEND_TEST_PUSH_FORM_FIELD_NAMES = {
  RECIPIENT,
  RECIPIENTS,
  MESSAGE,
};

export enum Recipient {
  SELF = 'self',
  ANOTHER = 'another',
}

export const sendTestPushFormSchema = z
  .object({
    [RECIPIENT]: z.nativeEnum(Recipient),
    [RECIPIENTS]: z
      .string()
      .refine(validateCommaSeparatedEmails, 'One or more email addresses are invalid'),
    [MESSAGE]: z.string().min(1, 'Message is required'),
  })
  .superRefine((data, ctx) => {
    if (data[RECIPIENT] === Recipient.ANOTHER && !data[RECIPIENTS]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'At least one email is required',
        path: [RECIPIENTS],
      });
    }
  });

export type SendTestPushFormSchema = z.infer<typeof sendTestPushFormSchema>;

const defaultValues = {
  [RECIPIENT]: Recipient.SELF,
  [RECIPIENTS]: '',
  [MESSAGE]: '',
};

export const SendTestPushFormProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const methods = useForm<SendTestPushFormSchema>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(sendTestPushFormSchema),
  });
  return <FormProvider {...methods}>{children}</FormProvider>;
};
